<template>
    <div>
        <el-form :inline="true">
            <el-form-item>
                <el-button type="primary" @click="dialogVisible = true">新增</el-button>
            </el-form-item>
        </el-form>

        <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                border
                stripe>
            <el-table-column
                    prop="title"
                    label="产品名称"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="price"
                    label="价格"
                    width="110">
            </el-table-column>
            <el-table-column
                    label="关联订阅计划"
                    width="150">
                <template slot-scope="scope">
                    {{ getPlanNameByRoleId(scope.row.roleId) || '-' }}
                </template>
            </el-table-column>
            <el-table-column
                    prop="delFlag"
                    label="状态"
                    width="110">
                <template slot-scope="scope">
                    <el-tag size="small" v-if="scope.row.delFlag == 0" type="success">启用</el-tag>
                    <el-tag size="small" v-else-if="scope.row.delFlag == 1" type="info">停用</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                    prop="icon"
                    label="操作">

                <template slot-scope="scope">
                    <el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
                    <el-divider direction="vertical"></el-divider>

                    <template>
                        <el-popconfirm title="这是一段内容确定删除吗？" @confirm="delHandle(scope.row.id, scope.row.delFlag)">
                            <el-button type="text" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                    <el-divider direction="vertical"></el-divider>

                    <el-button v-if="scope.row.delFlag == 1" type="text" @click="handleFlag(scope.row.id, 0)">启用</el-button>
                    <el-button v-else type="text" @click="handleFlag(scope.row.id, 1)">停用</el-button>
                </template>
            </el-table-column>

        </el-table>

        <!--新增对话框-->
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                width="500px"
                :before-close="handleClose">

            <el-form :model="editForm" :rules="editFormRules" ref="editForm">
                <el-form-item label="产品名称" prop="title" label-width="140px">
                    <el-input v-model="editForm.title" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="价格" prop="price" label-width="140px">
                    <el-input v-model="editForm.price" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="关联订阅计划" prop="roleName" label-width="140px">
                    <el-select v-model="editForm.roleId" style="width: 300px" placeholder="请选择订阅计划">
                        <el-option
                                v-for="plan in subscribePlanList"
                                :key="plan.id"
                                :label="plan.roleName || plan.name"
                                :value="plan.roleId || plan.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('editForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
  export default {
    name: "Product",
    data() {
      return {
        dialogVisible: false,
        editForm: {},
        tableData: [],
        editFormRules: {
          title: [
            {required: true, message: '请输入产品名称', trigger: 'blur'}
          ],
          price: [
            {required: true, message: '请输入价格', trigger: 'blur'}
          ],
          roleId: [
            {required: true, message: '请选择关联订阅计划', trigger: 'change'}
          ]
        },
        subscribePlanList: []
      }
    },
    created() {
      // 先加载订阅计划列表，再加载产品列表，确保表格中能正确显示订阅计划名称
      this.getSubscribePlanList()
      this.getProductList();
    },
    methods: {
      handleFlag(id, state) {
        this.$confirm('是否确认进行此操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post('/uxm/product/enableAndDisable/' + id +'/'+ state).then(res => {
            console.log('res',res)
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success'
              });
              this.getProductList();
            } else {
              this.$message.error('操作失败');
            }
          })
        }).catch(() => {
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.dialogVisible = false
        this.editForm = {}
      },
      handleClose() {
        this.resetForm('editForm')
      },

      getProductList() {
        this.$axios.get("/uxm/product/list", {}).then(res => {
          this.tableData = res.data.data
        })
      },
      submitForm(formName) {
        console.log('editForm', this.editForm)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post('/uxm/product/' + (this.editForm.id ? 'edit' : 'add'), this.editForm)
              .then(res => {
                this.$message({
                  showClose: true,
                  message: '恭喜你，操作成功',
                  type: 'success',
                });
                this.getProductList()
                this.dialogVisible = false
              })
          } else {
            return false;
          }
        });
      },
      editHandle(id) {
        this.$axios.get('/uxm/product/info/' + id).then(res => {
          this.editForm = res.data.data
          console.log("e", this.editForm)
          this.dialogVisible = true
        })
      },
      // 获取订阅计划配置列表（用于下拉选择）
      getSubscribePlanList() {
        this.$axios.get('/uxm/config/list', {}).then(res => {
          if (res && res.data && res.data.data) {
            // 使用计划配置中的订阅计划名称和角色ID
            this.subscribePlanList = res.data.data.map(config => ({
              id: config.id,
              roleId: config.roleId,
              roleName: config.roleName || '',
              name: config.roleName || '' // 兼容显示
            }))
            console.log("订阅计划列表", this.subscribePlanList)
          }
        }).catch(error => {
          console.error('获取订阅计划列表失败:', error)
          this.subscribePlanList = []
        })
      },
      // 根据roleId获取订阅计划名称
      getPlanNameByRoleId(roleId) {
        if (!roleId || !this.subscribePlanList || this.subscribePlanList.length === 0) {
          return ''
        }
        const plan = this.subscribePlanList.find(p => 
          String(p.roleId) === String(roleId) || String(p.id) === String(roleId)
        )
        return plan ? (plan.roleName || plan.name || '') : ''
      },
      delHandle(id, flag) {
        if (flag === 0) {
          return this.$message.warning("正在启用的情况下不能删除，请停用再删除！");
        }
        this.$axios.post('/uxm/product/remove/'+ id).then(res => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          });
          this.getProductList()
        })
      }
    }
  }
</script>

<style scoped>

    .el-pagination {
        float: right;
        margin-top: 22px;
    }

</style>
